"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./FormHeading.scss");
var FormHeading = function (_a) {
    var dusk = _a.dusk, label = _a.label;
    return (react_1.default.createElement("div", { "data-dusk": dusk, className: "form-heading" }, label));
};
exports.default = FormHeading;
//# sourceMappingURL=index.js.map